<template>
    <div class="vs-select" :class="{'multiple': header.multiple}" ref="vsSelect">
        <div v-if="mode === 'view'">
            <div v-if="selectedValue !== undefined && selectedValue !== null && Array.isArray(selectedValue)">
                <span v-for="item in selectedValue" class="badge badge-warning mb-1">{{ item[header.label] }}</span>
            </div>
            <div v-else-if="selectedValue !== undefined && selectedValue !== null && !Array.isArray(selectedValue)">
                <span class="badge badge-warning mb-1">{{ selectedValue[header.label] }}</span>
            </div>
        </div>
        <div v-if="mode === 'edit' || mode === 'create'">
            <v-select :class="{'no-border-radius': header.noBorderRadius}" dir="rtl" :label="header.label" :options="selectablesList" :multiple="header.multiple" v-model="selectedValue" @search:focus="onSearchFocused" @search:blur="onSearchBlurred">
                <span slot="no-options">موردی برای نمایش وجود ندارد.</span>
            </v-select>
        </div>
    </div>
</template>

<script>
    import vSelect from 'vue-select';
    import BaseService from './api/BaseService.js';

    export default {
        name: 'vs-select',
        props: {
            data: null,
            header: {
                default() {
                    return {
                        label: 'title',
                        multiple: false,
                        noBorderRadius: false
                    };
                },
                type: Object
            },
            headerKey: {
                default: '',
                type: String
            },
            mode: {
                default: 'view',
                type: String
            },
            selectedVal: {
                default() { return null; }
            },
            interval: null,
            options: {
                default() { return null; }
            },
            isHeader: {
                default: false,
                type: Boolean
            }
        },
        mounted() {
            if (this.$props.selectedVal !== null) {
                this.selectedValue = this.$props.selectedVal;
            }
            if(this.options != null) {
                new BaseService(null, this.header.listParams.requestURI).getRequest().then(response => {
                    this.selectablesList = response.data.data || response.data;

                    if(!this.isHeader) {
                        this.selectedValue = JSON.parse(JSON.stringify(this.data));
                    }
                }).catch(error => {
                    // error
                    //Utils.handleErrorWithNotification('خطا هنگام بارگذاری لیست.', this.$noty);
                });
            } else if(this.options == null) {
                this.selectablesList = JSON.parse(JSON.stringify(this.data));
            }
        },
        methods: {
            onSearchFocused() {
                this.$emit('onSearch', this.$refs.vsSelect);
            },
            onSearchBlurred() {
                this.$emit('onSearchBlurred', this.$refs.vsSelect);
            }
        },
        data() {
            return {
                selectedValue: null,
                selectablesList: []
            };
        },
        components: {
            vSelect
        },
        watch: {
            selectedValue(val) {
                this.$emit('onChange', val);
                this.$emit('dataChanged', this.headerKey, val);
            },
            selectedVal(val) {
                this.selectedValue = val;
            },
            data(val) {
                this.selectablesList = val;
            }
        }
    }
</script>

<style scoped>
    .no-border-radius {
        border-radius: 0;
    }
</style>